import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import * as allActions from "./actions";

/**
 * Hook providing bound action creators for the windows Redux slice.
 * @returns {Object} Bound action creators: updateWindows, updateWindowsSearchForm, updateWindowsForm, clearWindows, clearWindowForm
 */
export function useWindowsActions() {
  const dispatch = useDispatch();
  return useMemo(() => bindActionCreators(allActions, dispatch), [dispatch]);
}
